$(document).ready(function() {

  // Set the date we're counting down to    
  function countdown(dateEle) {
    var date = dateEle.getAttribute('data-attr');
    var countDownDate = new Date(date).getTime();

    // Update the count down every 1 second
    var x = setInterval(function() {

      // Get today's date and time
      var now = new Date().getTime();

      var distance = countDownDate - now;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      let launchDate = moment(date).format('MMMM Do');
      let launchTime = moment(date).format('HH:mma');
      let productLaunch = dateEle.parentElement.querySelector('.pc-product-launch');

      dateEle.innerHTML = '<span data-attr="days">'+days +'<span>days</span></span><span data-attr="hours">'+ hours +'<span>hours</span></span>'+
        '<span data-attr="mins">'+ minutes  +'<span>mins</span></span><span data-attr="secs">'+ seconds + '<span>secs</span></span>';
      // If the count down is finished, write some text
      productLaunch.querySelector('.launching_text').innerHTML = launchDate;
      productLaunch.querySelector('.launching_zone').innerHTML = launchTime;
      
      if (distance < 0) {
        clearInterval(x);
        productLaunch.querySelector('.launch').innerHTML = 'Launched';
        dateEle.innerHTML = "<span>00<span>Days<span></span></span></span><span>00<span>Hours<span></span></span></span><span>00<span>Mins<span></span></span></span><span>00<span>Secs<span></span></span></span>";
        $(dateEle).siblings('.pc-notify-me').find('.notifyme').addClass('btn_hide').siblings('.pc_link').removeClass('btn_hide');
      }
      else {
        $(dateEle).siblings('.pc-notify-me').find('.pc_link').addClass('btn_hide').siblings('.notifyme').removeClass('btn_hide');
      }
    }, 1000);
  }
  
  var dateEle = document.getElementsByClassName('pc-counter');
  var dateLen = dateEle.length;
  
  for(i=0;i<dateLen;i++) {
    var date_element = dateEle[i];
    countdown(date_element);
  }
  
  $('.product-countdown').slick({
    dots: false,
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" style=""><img src="//cdn.shopify.com/s/files/1/1358/1653/t/25/assets/arr1.svg" class="arrow"></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="//cdn.shopify.com/s/files/1/1358/1653/t/25/assets/arr2.svg" class="arrow"></path></button>'
  });
  $('.dynamic-collection-list--inner').slick({
    dots: false,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1
      }
    }
  ]
  })
});